import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose, bindActionCreators } from "redux";

import { Navigation } from "./navigation";
import { VideoListingComponent } from "./videoListing";
import { LoaderComponent } from "../../components/loader";
import cosmeticConfig from '../../../config/cosmeticConfig';

// actions
import {
  getExpertSubMenuAction,
  getExpertSubMenuDataAction,
  resetExpertResults,
  setSignupModalStatus,
  showLoader,
  hideLoader
} from "../../actions";

import { getParameterByName, getLastInputFromUrl, followButtonClicked, unFollowButtonClicked, checkFollowStatusById, IsEmpty, redirectToCompanyUrl } from "../../util/commonFunctions";
import { getEnv } from "../../../helpers/env";

class ExpertPage extends PureComponent {
  state = {
    activeTier: null,
    offset: cosmeticConfig.expert.OFFSET,
    max: cosmeticConfig.expert.MAX,
    isFollowing: false,
    lastScrollTop: 0

  };

  componentDidMount() {
    // get sub Menu List
    const { match: { url } = {}, location: { search } = {} } = this.props;
    let expertID = this.getExpertID()
    const isLoggedin = !IsEmpty(localStorage.getItem("token"))
    if(isLoggedin) {
      if (!IsEmpty(localStorage.getItem("userLastKnownLocation")) && decodeURIComponent(localStorage.getItem("userLastKnownLocation")) == getEnv("BASE_URL") + this.props.match.url + search && !IsEmpty(localStorage.getItem("isFollowClicked")) ){
        localStorage.setItem("userLastKnownLocation", '');
        this.followCompanyClicked()
      }
    }else {
      this.setState({isFollowing: false})
    }
    localStorage.setItem("isFollowClicked", '');
    this.getSubMenusList(expertID);
    this.getSubMenuListData(expertID);
    this.lazyLoadContainer = React.createRef();
    window.addEventListener("scroll", this.onScroll, false); // bind scroll event
  }

  openSigninModalPopup = (formName = "signin") => {
    this.props.setSignupModalStatus(true, formName);
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll, false);
  }

  componentDidUpdate(prevProps) {
    const {
      match: { url: newUrl },
      location: { search } = {}
    } = this.props;
    const {
      match: { url: oldUrl }
    } = prevProps;
    let expertID = this.getExpertID()
    if (oldUrl !== newUrl) {
      this.setState(
        {
          offset: 0,
          isFollowing: false
        },
        () => {
          this.props.resetExpertResults();
          this.getSubMenusList(expertID);
          this.getSubMenuListData(expertID);
        }
      );
    }
  }

  getExpertID = () => {
    const {
      location: { search } = {}
    } = this.props;
    let expertID = getParameterByName("expertID", search );
    if(!expertID || expertID == null){
        expertID = getLastInputFromUrl( search );
    }
    return expertID
  }



  followCompanyClicked = () => {
    const isLoggedin = !IsEmpty(localStorage.getItem("token"))
    let expertID = this.getExpertID()
    if(isLoggedin){
        followButtonClicked(this.followButtonApiHandler, localStorage.getItem("token") ,null, null, expertID)
    }else {
      localStorage.setItem("isFollowClicked", true);
      this.openSigninModalPopup("signin")
    }
  }

  followButtonApiHandler = (response,error) => {
    if(response){
      this.setState({
        isFollowing: true
      })
    }
  }

  unFollowCompanyClicked = () => {
    let expertID = this.getExpertID()
    unFollowButtonClicked(this.unFollowButtonApiHandler, this.props.token,null, null, expertID)
  }

  unFollowButtonApiHandler = (response, error) => {
    if (response) {
      this.setState({
        isFollowing: false
      })
    }
  }

  // get
  getSubMenusList = async id => {
    const { getExpertSubMenuAction, currentLanguage } = this.props;
    let token = localStorage.getItem("token")
    await getExpertSubMenuAction({ id, token, language: currentLanguage });
    this.setState({
      isFollowing: this.props.tierReducer?.subMenu?.isFollowing
    })
  };

  getSubMenuListData = async id => {
    const { max, offset } = this.state;
    const { getExpertSubMenuDataAction, currentLanguage } = this.props;
    let token = localStorage.getItem("token")
    await getExpertSubMenuDataAction({ id, offset, max, token, language: currentLanguage });
  };

  

  ///  lazy load on scroll
  onScroll = () => {
    const {
      match: { url } = {},
      location: { search } = {},
      tierReducer: { isSubMenuDataLoading, subMenuData }
    } = this.props;
    const {
      lastScrollTop
    } =  this.state
    let expertID = this.getExpertID()
    const {
      top: containerTop
    } = this.lazyLoadContainer.current.getBoundingClientRect();
    var st = window.pageYOffset || document.documentElement.scrollTop; 
    if (st > lastScrollTop) {
      this.setState({
        lastScrollTop: st <= 0 ? 0 : st 
      })
      // downscroll code
    } else {
      this.setState({
        lastScrollTop: st <= 0 ? 0 : st
      })
      return;
      // upscroll code
    }
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 200) {
      const listing =
        subMenuData &&
        Object.values(subMenuData).map(values => values.contentResults);
      const lastList =
        Array.isArray(listing) && listing.length && listing[listing.length - 1];
        const totalCount =
        subMenuData &&
        Object.values(subMenuData).map(values => values.totalCount);
      if (!isSubMenuDataLoading && containerTop < 100 && lastList.length && this.state.offset <= totalCount) {
        this.setState(
          prevState => ({
            offset: prevState.offset + prevState.max
          }),
          () => {
            this.getSubMenuListData(expertID);
          }
        );
      }
    }
  };

  // on click on navigation tier
  onTierClicked = async({ id }) => {
  };

  render() {
    const { onTierClicked, followCompanyClicked, unFollowCompanyClicked } = this;
    const { tierReducer, location } = this.props;
    const {
      subMenu = {},
      subMenuData = {},
      isSubMenuDataLoading
    } = tierReducer;

    //Total items count and items from list
    let totalResults = 0;
    let tierTotalResults = 0;
    const listing =
      subMenuData &&
      Object.values(subMenuData).map(values => {
        totalResults += values.contentResults
          ? values.contentResults.length
          : 0;
        return values.contentResults;
      });

    return (
      <React.Fragment>
        <div className="contentWhite">
          <section className="tier-container">
            <LoaderComponent isLoading={isSubMenuDataLoading} />
            <section className="tier-navigation">
              <Navigation
                title={subMenu}
                pathName={location && location.pathname}
                followCompanyClicked={followCompanyClicked}
                isFollowing={this.state.isFollowing}
                onTierClicked={onTierClicked}
                unFollowCompanyClicked={unFollowCompanyClicked}
                listing={subMenu?.expertiseList}
                redirectToCompanyPage ={(event) => {
                  redirectToCompanyUrl(
                    event,
                    subMenu?.companyId,
                    subMenu?.companyName,
                    this.props,
                    this.props.showLoader,
                    this.props.hideLoader
                  )
                }}
                contentArr={listing?.length > 0 ? listing[0] : []}
              />
            </section>
            <section
              className="container tier-listing"
              ref={this.lazyLoadContainer}
            >
              <div className="row">
                <VideoListingComponent
                  listing={listing}
                  totalResults={totalResults}
                  isLoading={!isSubMenuDataLoading}
                />
              </div>
            </section>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    tierReducer: state.expertPage,
    token: state.auth.token,
    currentLanguage: state.language.currentLanguage
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getExpertSubMenuAction,
      getExpertSubMenuDataAction,
      resetExpertResults,
      setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm)),
      showLoader: () => dispatch(showLoader()),
      hideLoader: () => dispatch(hideLoader())
    },
    dispatch
  );
}

function loadData(store) {
  return store.dispatch(getExpertSubMenuDataAction());
}

export default {
  component: compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
  )(ExpertPage)
};
